<script lang="ts">
export default defineNuxtComponent({
    props: {
        type: String,
    },
    setup(props, { slots }) {
        return () =>
            h(
                props.type as PageHeaderHeadingType,
                {
                    class: 'page-header-heading mb-3 mx-lg-auto alfa',
                },
                (slots.default as Function)()
            )
    },
})
</script>
